import { RootAction } from "../types";
import {
  CLOSE_USER_CONVERSATION,
  MINIMIZE_USER_CONVERSATION,
  OPEN_USER_CONVERSATION,
} from "./actions";
import { UserConversationsActiveState } from "./types";

const initialuserConversationState: UserConversationsActiveState = {
  open: [],
  minimized: [],
};

export function userConversationReducer(
  state = initialuserConversationState,
  action: RootAction
): UserConversationsActiveState {
  switch (action.type) {
    case OPEN_USER_CONVERSATION:
      return {
        ...state,
        open: state.open.some((item) => item.id === action.id)
          ? state.open
          : [...state.open, { id: action.id, objectType: action.objectType }],
        minimized: state.minimized.filter((item) => item.id !== action.id),
      };

    case MINIMIZE_USER_CONVERSATION:
      return {
        ...state,
        open: state.open.filter((item) => item.id !== action.id),
        minimized: state.minimized.some((item) => item.id === action.id)
          ? state.minimized
          : [
              ...state.minimized,
              { id: action.id, objectType: action.objectType },
            ],
      };

    case CLOSE_USER_CONVERSATION:
      return {
        ...state,
        open: state.open.filter((item) => item.id !== action.id),
        minimized: state.minimized.filter((item) => item.id !== action.id),
      };

    default:
      return state;
  }
}
